import React from "react";
import { Card, Nav, Container, Row, Col, Tab, Spinner } from "react-bootstrap";

import { useSelector } from "react-redux";

import PengajuanKonsumtif from "./Pengajuan";
import PengajuanProduktif from "./PengajuanProduktif";
function indexPengajuan() {
  const auth = useSelector((state) => state.authReducer);
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const kategori = auth?.akses;
  const isSuperAdmin =
    auth.role === "super admin" ||
    auth.role === "area manager" ||
    auth.role === "koordinator wilayah";
  const hasFullAccess = isSuperAdmin || kategori?.length === 2;
  const aksesPertama = kategori?.[0];
  const loading =
    !auth || (!isSuperAdmin && (!kategori || kategori.length === 0));
  const isDetailPengajuanMode = pengajuan.closeTabPengajuan;
  const loadingDetailPengajuan = pengajuan.loadingDetailPengajuan;
  // return (
  //   <>
  //     <Container fluid>
  //       <Row>
  //         <Col md="12">
  //           <Card>
  //             {/* <Card.Header>
  //               <Card.Title
  //                 as="h3"
  //                 style={{
  //                   color: "black",
  //                   textTransform: "uppercase",
  //                   fontWeight: "bold",
  //                 }}
  //               >
  //                 List Pengajuan
  //               </Card.Title>
  //             </Card.Header> */}
  //             <Card.Body>
  //               {/* {loading ? (
  //                 <Container
  //                   fluid
  //                   className=" d-flex justify-content-center align-items-center"
  //                 >
  //                   <Row>
  //                     <Col className="text-center">
  //                       <span
  //                         style={{
  //                           fontWeight: "bold",
  //                           color: "blue",
  //                           fontSize: 20,
  //                         }}
  //                       >
  //                         Loading...
  //                       </span>
  //                     </Col>
  //                   </Row>
  //                 </Container>
  //               ) : hasFullAccess ? ( */}
  //               <Tab.Container
  //                 id="plain-tabs-example"
  //                 defaultActiveKey={"pengajuanKonsumtif"}
  //               >
  //                 {!(
  //                   // isSuperAdmin &&
  //                   // hasFullAccess &&
  //                   isDetailPengajuanMode
  //                 ) && (
  //                   <Nav role="tablist" variant="tabs">
  //                     <Nav.Item>
  //                       <Nav.Link
  //                         eventKey="pengajuanKonsumtif"
  //                         style={{ color: "#134686", fontWeight: "bold" }}
  //                       >
  //                         Konsumtif
  //                       </Nav.Link>
  //                     </Nav.Item>
  //                     {/* <Nav.Item>
  //                         <Nav.Link
  //                           eventKey="pengajuanProduktif"
  //                           style={{ color: "#134686", fontWeight: "bold" }}
  //                         >
  //                           Produktif
  //                         </Nav.Link>
  //                       </Nav.Item> */}
  //                   </Nav>
  //                 )}

  //                 <Tab.Content>
  //                   <Tab.Pane eventKey="pengajuanKonsumtif">
  //                     <PengajuanKonsumtif />
  //                   </Tab.Pane>
  //                   {/* <Tab.Pane eventKey="pengajuanProduktif">
  //                     <PengajuanProduktif />
  //                   </Tab.Pane> */}
  //                 </Tab.Content>
  //               </Tab.Container>
  //               {/* ) : aksesPertama === "konsumtif" ? (
  //                 <PengajuanKonsumtif />
  //               ) : aksesPertama === "produktif" ? (
  //                 <PengajuanProduktif />
  //               ) : (
  //                 <Container
  //                   fluid
  //                   className=" d-flex justify-content-center align-items-center"
  //                 >
  //                   <Row>
  //                     <Col className="text-center">
  //                       <span
  //                         style={{
  //                           fontWeight: "bold",
  //                           color: "red",
  //                           fontSize: 20,
  //                         }}
  //                       >
  //                         Maaf, Anda tidak memiliki akses!
  //                       </span>
  //                     </Col>
  //                   </Row>
  //                 </Container>
  //               )} */}
  //             </Card.Body>
  //           </Card>
  //         </Col>
  //       </Row>
  //     </Container>
  //   </>
  // );

  return (
    <>
      {isDetailPengajuanMode && loadingDetailPengajuan ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <div className="mt-2 fw-bold text-primary">Loading detail...</div>
        </div>
      ) : isDetailPengajuanMode ? (
        <PengajuanKonsumtif />
      ) : (
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="pengajuan-page-shell">
                <Card.Body>
                  <Tab.Container
                    id="plain-tabs-example"
                    defaultActiveKey="pengajuanKonsumtif"
                  >
                    <Nav role="tablist" variant="tabs" className="pengajuan-page-tabs">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="pengajuanKonsumtif"
                          style={{ color: "#134686", fontWeight: "bold" }}
                        >
                          Konsumtif
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content>
                      <Tab.Pane eventKey="pengajuanKonsumtif">
                        <PengajuanKonsumtif />
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default indexPengajuan;
